import { FC, useMemo } from "react";
import { Box, Grid, Paper } from "@mui/material";
import { useForm, useWatch } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { AppRoutes } from "../../../../common/routesUtils";
import { View } from "../../../../components/layout/View";
import { PageType } from "../../../../config/page.types";
import { useBreadcrumbs } from "../../../../context/BreadcrumbsProvider";
import { CarbonSnapFormData } from "../../../../datasources/carbonsnap/models";
import { emptyCarbonSnapFormData } from "../../../../datasources/carbonsnap/utils";
import CarbonSnapMap from "../shared/components/CarbonSnapMap";
import TripComposer from "./components/TripComposer";
import TripDataFields from "./components/TripDataFields";

const CarbonSnapComposer: FC = () => {
	const navigateTo = useNavigate();
	const { visitPage } = useBreadcrumbs();

	const form = useForm<CarbonSnapFormData>({
		defaultValues: emptyCarbonSnapFormData,
	});

	// Osserva i cambiamenti ai nodi per aggiornare la mappa
	const nodes = useWatch({
		control: form.control,
		name: "nodes",
	});
	const arcs = useWatch({
		control: form.control,
		name: "arcs",
	});

	const isCalculable = useMemo(() => {
		return (nodes ?? []).filter((node) => node.lat !== null && node.lng !== null).length >= 2;
	}, [nodes]);

	const handleCalculate = () => {
		// TODO: Navigate to results page
		// Used to update bredcrumbs
		visitPage(PageType.AdditionalServicesCarbonSnapResults);
		navigateTo(AppRoutes.AdditionalServicesCarbonSnapResults);
	};

	return (
		<View
			pageType={PageType.AdditionalServicesCarbonSnap}
			headerContext={{
				onBackToList: () => navigateTo(AppRoutes.AdditionalServices),
				onCalculate: handleCalculate,
				calculateDisabled: !isCalculable,
			}}
		>
			<Grid container spacing={3}>
				<Grid size={{ xs: 12, lg: 6 }} sx={{ minWidth: 0 }}>
					<Box sx={{ display: "flex", flexDirection: "column", gap: 3, minWidth: 0 }}>
						<Paper sx={{ p: 3 }}>
							<Grid container spacing={2}>
								<TripDataFields form={form} />
							</Grid>
						</Paper>

						<Paper sx={{ p: 3 }}>
							<Grid container spacing={2}>
								<TripComposer form={form} />
							</Grid>
						</Paper>
					</Box>
				</Grid>
				<Grid size={{ xs: 12, lg: 6 }} sx={{ minHeight: 400 }}>
					<CarbonSnapMap nodes={nodes ?? []} arcs={arcs ?? []} />
				</Grid>
			</Grid>
		</View>
	);
};

export default CarbonSnapComposer;
